<template>
    <div class="base-panel">
        <div class="base-panel-head space-between">
            <div>PR排行 <i class="fa icon" :class="orderClass[order]" @click="changeOrder()"></i></div>
            <div class="dark">
                <a-select class="station-type" v-model="type"  defaultValue="0"   @change="handleChange" :getPopupContainer="
                                  triggerNode => {
                                    return triggerNode.parentNode || document.body;
                                  }
                                ">
                    <a-select-option value="3">当日</a-select-option>
                    <a-select-option value="2">当月</a-select-option>
                    <a-select-option value="1">当年</a-select-option>
                </a-select>
            </div>
        </div>
        <div class="base-panel-body-auto padding-10">
            <vuescroll :ops="scroll">
                <template v-if="list.length > 0">
                    <circle-percent v-for="item in list" :key="item.id" :data="{percent: item.percent, title: item.title}"></circle-percent>
                </template>
                <template v-else-if="list.length === 0">
                    <a-empty style="padding-top: 30px" />
                </template>
            </vuescroll>
        </div>
    </div>
</template>

<script>
    import vuescroll from 'vuescroll/dist/vuescroll-native';
    import CirclePercent from "@/components/CirclePercent/CirclePercent";
    export default {
        name: "PRRank",
        components:{
            vuescroll,
            CirclePercent
        },
        data(){
            return {
                groupId: 0,
                type: '3',
                order: 1,  //0升序, 1降序
                list: [],
                orderClass: ['fa-sort-amount-asc', 'fa-sort-amount-desc'],
                scroll: {
                    vuescroll: {},
                    scrollPanel: {},
                    rail: {
                        gutterOfSide: '0px',
                    },
                    bar: {
                        background: '#1ab394',
                    }
                }
            }
        },
        mounted(){
            this.groupId = this.$Utils.getUserStorage().groupId;
            this.initData();
        },
        methods:{
            async initData(){

                let result = await this.$http.get(this.$baseURL.generateHourRank({groupId: this.groupId, timeDimension: this.type, order: this.order + 1 }));
                let array = [];
                result.forEach(item => {
                    array.push({
                        id: item.id,
                        title: item.name,
                        percent: item.avgPR
                    })
                });

                this.list = array;
            },
            handleChange(){
                this.initData();
            },
            changeOrder(){
                this.order = (this.order === 0) ? 1 : 0;
                this.initData();
            }
        }

    }
</script>

<style scoped>
    .icon {
        padding: 4px;
        border: 1px solid #eee;
        border-radius: 3px;
        font-size: 12px;
        cursor: pointer;
    }
</style>
